
    const original = "<svg width=\"310\" height=\"310\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" overflow=\"hidden\"><g transform=\"translate(-2551 -1439)\"><path d=\"M2674 1572 2780 1572 2778.38 1588C2769.96 1629.09 2733.55 1660 2689.91 1660L2674 1658.4 2674 1572Z\" fill=\"#855CD6\" fill-rule=\"evenodd\"/><path d=\"M2680 1471C2729.71 1471 2770 1511.43 2770 1561.3L2769.78 1563.48 2664.14 1563.48 2664.14 1650 2661.86 1649.77C2620.85 1641.35 2590 1604.94 2590 1561.3 2590 1511.43 2630.29 1471 2680 1471Z\" fill=\"#855CD6\" fill-rule=\"evenodd\"/><path d=\"M2788.74 1581 2828 1581 2828 1726 2683 1726 2683 1667.32 2698.87 1668.92C2742.41 1668.92 2778.73 1638.04 2787.13 1596.99L2788.74 1581Z\" fill=\"#855CD6\" fill-rule=\"evenodd\"/></g></svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original
                .replace(/#855cd6/gi, Recolor.primary)
                .replace(/#A384E0/gi, Recolor.primaryLight || Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
